export default {"src":"/_next/static/media/assurance-dommages.5a59b91d.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};